import React, { useEffect } from "react";
import PropTypes from "prop-types";

import "./taboola.m.css";

const TaboolaAd = ({ container, placement, mode }) => {
  useEffect(() => loadScript(), []);

  const loadScript = () => {
    window._taboola = window._taboola || [];
    // eslint-disable-next-line
    _taboola.push({
      mode: mode,
      container: container,
      placement: placement,
      target_type: "mix"
    });

    _taboola.push({ flush: true }); // eslint-disable-line
  };

  return (
    <div styleName="ad-wrapper" id="ad-wrapper-taboola">
      <div id={container} />
    </div>
  );
};

TaboolaAd.propTypes = {
  container: PropTypes.string,
  placement: PropTypes.string,
  mode: PropTypes.string
};

export default TaboolaAd;
